<div
  class="pb-4 px-6 py-4 breadborder sticky-header_bredcrumb"
  style="background-color: var(--app-surface-subtle)"
  fxLayout="column"
  fxLayoutAlign="center start"
>
  <div class="w-full flex flex-col sm:flex-row justify-between">
    <vex-breadcrumbs
      class="cursor-pointer"
      [routerLink]="['/view-encounters']"
      [crumbs]="['View Encounters']"
    ></vex-breadcrumbs>
  </div>
  <div class="w-full flex flex-col sm:flex-row justify-between mt-1 ml-2">
    <span class="text-black text-xl font-medium">View Encounters</span>
  </div>
</div>

<div
  class="card px-6 py-3 sticky-header_filter border-b sticky left-0"
  fxLayout="row"
  fxLayoutAlign="start center"
>
  <div
    class="bg-card rounded-full px-4"
    fxFlex="340px"
    fxLayout="row"
    fxLayoutAlign="start center"
    style="border: 1px solid #516685"
  >
    <ic-icon [icIcon]="icSearch" size="18px" style="color: #516685"></ic-icon>
    <input
      #searchInput
      type="text"
      placeholder="Search..."
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchChange($event)"
      class="px-4 py-3 border-0 outline-none w-full bg-transparent text-sm"
      type="search"
      fxFlex="auto"
      style="color: #516685"
    />
  </div>
  <!-- <mat-spinner *ngIf="isSearchLoading" diameter="20" style="margin-left: 10px;"></mat-spinner> -->

  <span fxFlex></span>
  <mat-menu
    #statusMenu="matMenu"
    [overlapTrigger]="false"
    class="custom-menu_2"
  >
    <div
      *ngFor="let status of statusOptions"
      class="menu-item"
      (click)="$event.stopPropagation()"
    >
      <mat-checkbox
        [checked]="selectedStatuses.includes(status.value)"
        (change)="toggleStatusSelection(status.value)"
      >
        {{ status.label }}
      </mat-checkbox>
    </div>

    <div class="menu-footer">
      <button
        mat-button
        color="primary"
        class="footer-btn reset-btn"
        (click)="resetStatusFilter()"
      >
        Reset
      </button>
      <button
        mat-flat-button
        color="primary"
        class="footer-btn apply-btn"
        (click)="applyStatusFilter(statusMenuTrigger)"
      >
        Apply
      </button>
    </div>
  </mat-menu>

  <button
    mat-button
    [matMenuTriggerFor]="statusMenu"
    #statusMenuTrigger="matMenuTrigger"
    class="filter-button"
    [class.active]="statusMenuTrigger.menuOpen"
  >
    <mat-icon class="theme-filter-icon ml-2" aria-hidden="true">filter_alt</mat-icon>
    {{ selectedStatusLabel || "Filter" }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <button
    *ngIf="selectedStatuses.length > 0"
    mat-button
    color="primary"
    class="footer-btn reset-btn"
    (click)="resetStatusFilter()"
  >
    <img src="assets/reset.png" alt="Filter" class="w-6 h-6 ml-1" />
  </button>
  <button
    class="m-2 qqmeIcon-2"
    mat-button
    matTooltip="Create Encounter"
    routerLink="/calendar/create_encounter"
    type="button"
  >
    <mat-icon>add</mat-icon>
    <span>New encounter</span>
  </button>
  <button
    class="m-2 qqmeIcon-2"
    mat-button
    matTooltip="Create SIBTF"
    routerLink="/calendar/create_sibtf_encounter"
    type="button"
  >
    <mat-icon>add</mat-icon>
    <span>New SIBTF</span>
  </button>
  <button
    *ngIf="canCreatePiEncounter()"
    class="m-2 qqmeIcon-2"
    mat-button
    matTooltip="Create Case"
    routerLink="/calendar/create_pi_encounter"
    type="button"
  >
    <mat-icon>add</mat-icon>
    <span>New Case</span>
  </button>
</div>
<div *ngIf="isLoading" class="flex justify-center py-6">
  <mat-spinner class="spin" diameter="40"></mat-spinner>
</div>
<div *ngIf="!isLoading">
  <div *ngIf="errorMessage; else tableContent" class="px-6 py-10">
    <div fxLayout="column" fxLayoutAlign="center center">
      <img class="h-40" src="assets/unauthorized.png" />
      <h2 class="headline m-0 text-center">Unauthorized Access</h2>
      <p class="mt-2 text-center m-0">{{ errorMessage }}</p>

      <div class="text-center mt-4">
        <button
          class="qqmeIcon-2"
          mat-button
          matTooltip="Back"
          routerLink="/calendar"
          type="button"
        >
          <mat-icon>arrow_backward</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <ng-template #tableContent>
    <div class="px-6 py-2 mt-3">
      <div
        style="
          max-height: 63vh;
          overflow: scroll;
          border-radius: 1rem;
          scroll-behavior: smooth;
        "
        class="scroll-hide"
        (scroll)="onEncounterScroll($event)"
      >
        <ng-container *ngIf="dataSource?.data?.length > 0; else noData">
          <table
            [dataSource]="dataSource"
            (matSortChange)="sortData($event)"
            class="w-full pb-10"
            mat-table
            matSort
            [matSortActive]="sortStates.column"
            [matSortDirection]="sortStates.direction"
            [matSortStart]="'desc'"
            [matSortDisableClear]="true"
          >
            <ng-container
              *ngFor="let column of columns; trackBy: trackByProperty"
            >
              <!-- Sticky column for fullName -->
              <ng-container
                *ngIf="column.type === 'text' && column.property === 'fullName'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  mat-sort-header
                  [disabled]="!column.sortable"
                  sticky
                  [ngClass]="{
                    'sticky-header': true,
                    'sticky-left': column.property === 'fullName'
                  }"
                >
                  {{ column.label }}
                </th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                  sticky
                >
                  <ng-container *ngIf="column.property === 'fullName'">
                    <ng-container *ngIf="row.draft == 'false' || row.draft == null; else planText">
                      <ng-container *ngIf="!row.isReqForm">
                        <!-- Completed pre-ingestion (bulk or standard) → patient profile -->
                        <ng-container
                          *ngIf="row.isCompletedPreIngestion === true"
                        >
                          <a
                            [routerLink]="[
                              '/reports/patient_profile',
                              row.applicantID
                            ]"
                            class="t2 cursor-pointer"
                          >
                            {{
                              row[column.property]
                                ? (row[column.property] | titlecase)
                                : "--"
                            }}
                          </a>
                        </ng-container>

                        <!-- Custom routing for specific encounter types -->
                        <ng-container
                          *ngIf="
                            row.isCompletedPreIngestion !== true &&
                            ['PQME', 'AME', 'PQMER', 'AMER', 'SIBTF'].includes(
                              row.encounterType
                            )
                          "
                        >
                          <ng-container
                            *ngIf="
                              getFirstAvailableSubComponent() as subComponent
                            "
                          >
                            <a
                              [routerLink]="[subComponent.route]"
                              [queryParams]="{ id: row._id }"
                              class="t2 cursor-pointer"
                            >
                              {{
                                row[column.property]
                                  ? (row[column.property] | titlecase)
                                  : "--"
                              }}
                            </a>
                          </ng-container>
                        </ng-container>

                        <ng-container
                          *ngIf="
                            row.isCompletedPreIngestion !== true &&
                            this.roleName !== 'PHYSICIAN' &&
                            [
                              'PQMES',
                              'AMES',
                              'Reflex PQMES',
                              'Reflex AMES'
                            ].includes(row.encounterType)
                          "
                        >
                          <ng-container
                            *ngIf="
                              getFirstAvailablePQMESSubComponent() as subComponent
                            "
                          >
                            <a
                              [routerLink]="[subComponent.route]"
                              [queryParams]="{ id: row._id }"
                              class="t2 cursor-pointer"
                            >
                              {{
                                row[column.property]
                                  ? (row[column.property] | titlecase)
                                  : "--"
                              }}
                            </a>
                          </ng-container>
                        </ng-container>

                         <ng-container
                          *ngIf="
                            row.isCompletedPreIngestion !== true &&
                            this.roleName === 'PHYSICIAN' &&
                            [
                              'PQMES',
                              'AMES',
                              'Reflex PQMES',
                              'Reflex AMES'
                            ].includes(row.encounterType)
                          "
                        >
                          <ng-container
                            *ngIf="
                              getFirstAvailablePQMES_pyhisicianSubComponent() as subComponent
                            "
                          >
                            <a
                              [routerLink]="[subComponent.route]"
                              [queryParams]="{ id: row._id }"
                              class="t2 cursor-pointer"
                            >
                              {{
                                row[column.property]
                                  ? (row[column.property] | titlecase)
                                  : "--"
                              }}
                            </a>
                          </ng-container>
                        </ng-container>

                        <ng-container
                          *ngIf="
                            row.isCompletedPreIngestion !== true &&
                            ['PQMED', 'AMED'].includes(row.encounterType)
                          "
                        >
                          <ng-container
                            *ngIf="
                              getDepositionAvailableSubComponent() as subComponent
                            "
                          >
                            <a
                              [routerLink]="[subComponent.route]"
                              [queryParams]="{ id: row._id }"
                              class="t2 cursor-pointer"
                            >
                              {{
                                row[column.property]
                                  ? (row[column.property] | titlecase)
                                  : "--"
                              }}
                            </a>
                          </ng-container>
                        </ng-container>

                        <ng-container
                          *ngIf="
                            row.isCompletedPreIngestion !== true &&
                            row.encounterType === 'Personal Injury'
                          "
                        >
                          <a
                            (click)="openPiEncounter(row._id, row)"
                            class="t2 cursor-pointer"
                          >
                            {{
                              row[column.property]
                                ? (row[column.property] | titlecase)
                                : "--"
                            }}
                          </a>
                        </ng-container>

                        <ng-container
                          *ngIf="
                            row.isCompletedPreIngestion !== true &&
                            ![
                              'PQME',
                              'AME',
                              'PQMER',
                              'AMER',
                              'SIBTF',
                              'PQMES',
                              'AMES',
                              'Reflex PQMES',
                              'Reflex AMES',
                              'PQMED',
                              'AMED',
                              'Personal Injury'
                            ].includes(row.encounterType)
                          "
                        >
                          <a
                            [routerLink]="[
                              '/reports/patient_profile',
                              row.applicantID
                            ]"
                            class="t2 cursor-pointer"
                          >
                            {{
                              row[column.property]
                                ? (row[column.property] | titlecase)
                                : "--"
                            }}
                          </a>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <ng-template #planText>
                      {{
                        row[column.property]
                          ? (row[column.property] | titlecase)
                          : "--"
                      }}
                    </ng-template>
                  </ng-container>
                </td>
              </ng-container>

              <!-- Non-sticky columns for other text properties -->
              <ng-container
                *ngIf="column.type === 'text' && column.property !== 'fullName'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  mat-sort-header
                  [disabled]="!column.sortable"
                >
                  {{ column.label }}
                </th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  {{
                    column.property === "encounterType"
                      ? displayEncounterOrCaseType(row)
                      : isValidValue(row[column.property])
                        ? row[column.property]
                        : "--"
                  }}
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'badge_2'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  [innerHTML]="column.label"
                ></th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <!-- {{ row[column.property] | date : "MM/dd/yyyy" : "UTC" }} -->
                         {{ row[column.property] | date : "MM/dd/yyyy" : 'UTC'}}
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'date'"
                [matColumnDef]="column.property"
              >
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  [disabled]="!column.sortable"
                  class="sticky-header tabel_header"
                >
                  {{ column.label }}
                </th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container
                    *ngIf="
                      column.property === 'dateOfAppointment' &&
                        (row.encounterType === 'PQMES' ||
                          row.encounterType === 'Reflex PQMES' ||
                          row.encounterType === 'AMES' ||
                          row.encounterType === 'Reflex AMES');
                      else showDateCell
                    "
                  ></ng-container>
                  <ng-template #showDateCell>
                    {{
                      isValidValue(row[column.property])
                        ? (row[column.property] | date : "MM/dd/yyyy" : "UTC")
                        : "--"
                    }}
                  </ng-template>
                </td>              </ng-container>

              <ng-container
                *ngIf="column.type === 'badge_3'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  [innerHTML]="column.label"
                ></th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container
                    *ngIf="
                      isValidValue(row.reqDateRange_start) &&
                        isValidValue(row.reqDateRange_end);
                      else noRequestedRange
                    "
                  >
                    {{ row.reqDateRange_start | date : "MM/dd/yyyy" : "UTC" }}
                    -
                    {{ row.reqDateRange_end | date : "MM/dd/yyyy" : "UTC" }}
                  </ng-container>
                  <ng-template #noRequestedRange>--</ng-template>
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'badge_4'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  [innerHTML]="column.label"
                ></th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container
                    *ngIf="
                      displayDigitalService(row, column.property) === 'Accepted';
                      else textDisplay
                    "
                  >
                    <button
                      mat-icon-button
                      (click)="viewApplicantServiceFrom(row)"
                      aria-label="View Applicant Service"
                    >
                      Accepted
                      <mat-icon class="pdf-icon" matTooltip="View" color="warn"
                        >picture_as_pdf</mat-icon
                      >
                    </button>
                  </ng-container>
                  <ng-template #textDisplay>
                    <ng-container
                      *ngIf="
                        hasDigitalServiceStatus(row, column.property) &&
                          canCopyConsentPermalinkForRow(row, column.property);
                        else plainStatus
                      "
                    >
                      {{ displayDigitalService(row, column.property) }}
                      <mat-icon
                        class="text-gray cursor-pointer"
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;"
                        matTooltip="Copy invite link"
                        (click)="copyConsentPermalinkForRow(row, column.property)"
                      >
                        content_copy
                      </mat-icon>
                    </ng-container>
                    <ng-template #plainStatus>
                      {{ displayDigitalService(row, column.property) }}
                    </ng-template>
                  </ng-template>
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'badge_5'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  [innerHTML]="column.label"
                ></th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container
                    *ngIf="
                      displayDigitalService(row, column.property) === 'Accepted';
                      else textDisplay
                    "
                  >
                    <button
                      mat-icon-button
                      (click)="viewApplicantAttorneyServiceFrom(row)"
                      aria-label="View Service"
                    >
                      Accepted
                      <mat-icon class="pdf-icon" matTooltip="View" color="warn"
                        >picture_as_pdf</mat-icon
                      >
                    </button>
                  </ng-container>
                  <ng-template #textDisplay>
                    <ng-container
                      *ngIf="
                        hasDigitalServiceStatus(row, column.property) &&
                          canCopyConsentPermalinkForRow(row, column.property);
                        else plainStatus
                      "
                    >
                      {{ displayDigitalService(row, column.property) }}
                      <mat-icon
                        class="text-gray cursor-pointer"
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;"
                        matTooltip="Copy invite link"
                        (click)="copyConsentPermalinkForRow(row, column.property)"
                      >
                        content_copy
                      </mat-icon>
                    </ng-container>
                    <ng-template #plainStatus>
                      {{ displayDigitalService(row, column.property) }}
                    </ng-template>
                  </ng-template>
                </td>
              </ng-container>
              <ng-container
                *ngIf="column.type === 'badge_6'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  [innerHTML]="column.label"
                ></th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container
                    *ngIf="
                      displayDigitalService(row, column.property) === 'Accepted';
                      else textDisplay
                    "
                  >
                    <button
                      mat-icon-button
                      (click)="viewdefenseAttorneyServiceFrom(row)"
                      aria-label="View Service"
                    >
                      Accepted
                      <mat-icon class="pdf-icon" matTooltip="View" color="warn"
                        >picture_as_pdf</mat-icon
                      >
                    </button>
                  </ng-container>
                  <ng-template #textDisplay>
                    <ng-container
                      *ngIf="
                        hasDigitalServiceStatus(row, column.property) &&
                          canCopyConsentPermalinkForRow(row, column.property);
                        else plainStatus
                      "
                    >
                      {{ displayDigitalService(row, column.property) }}
                      <mat-icon
                        class="text-gray cursor-pointer"
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;"
                        matTooltip="Copy invite link"
                        (click)="copyConsentPermalinkForRow(row, column.property)"
                      >
                        content_copy
                      </mat-icon>
                    </ng-container>
                    <ng-template #plainStatus>
                      {{ displayDigitalService(row, column.property) }}
                    </ng-template>
                  </ng-template>
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'badge_7'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  [innerHTML]="column.label"
                ></th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container
                    *ngIf="
                      displayDigitalService(row, column.property) === 'Accepted';
                      else textDisplay
                    "
                  >
                    <button
                      mat-icon-button
                      (click)="viewEmployerServiceFrom(row)"
                      aria-label="View Service"
                    >
                      Accepted
                      <mat-icon class="pdf-icon" matTooltip="View" color="warn"
                        >picture_as_pdf</mat-icon
                      >
                    </button>
                  </ng-container>
                  <ng-template #textDisplay>
                    <ng-container
                      *ngIf="
                        hasDigitalServiceStatus(row, column.property) &&
                          canCopyConsentPermalinkForRow(row, column.property);
                        else plainStatus
                      "
                    >
                      {{ displayDigitalService(row, column.property) }}
                      <mat-icon
                        class="text-gray cursor-pointer"
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;"
                        matTooltip="Copy invite link"
                        (click)="copyConsentPermalinkForRow(row, column.property)"
                      >
                        content_copy
                      </mat-icon>
                    </ng-container>
                    <ng-template #plainStatus>
                      {{ displayDigitalService(row, column.property) }}
                    </ng-template>
                  </ng-template>
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'badge_8'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  [innerHTML]="column.label"
                ></th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container
                    *ngIf="
                      displayDigitalService(row, column.property) === 'Accepted';
                      else textDisplay
                    "
                  >
                    <button
                      mat-icon-button
                      (click)="viewAdjusterServiceFrom(row)"
                      aria-label="View Service"
                    >
                      Accepted
                      <mat-icon class="pdf-icon" matTooltip="View" color="warn"
                        >picture_as_pdf</mat-icon
                      >
                    </button>
                  </ng-container>
                  <ng-template #textDisplay>
                    <ng-container
                      *ngIf="
                        hasDigitalServiceStatus(row, column.property) &&
                          canCopyConsentPermalinkForRow(row, column.property);
                        else plainStatus
                      "
                    >
                      {{ displayDigitalService(row, column.property) }}
                      <mat-icon
                        class="text-gray cursor-pointer"
                        style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;"
                        matTooltip="Copy invite link"
                        (click)="copyConsentPermalinkForRow(row, column.property)"
                      >
                        content_copy
                      </mat-icon>
                    </ng-container>
                    <ng-template #plainStatus>
                      {{ displayDigitalService(row, column.property) }}
                    </ng-template>
                  </ng-template>
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'badge'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  mat-sort-header
                  [disabled]="!column.sortable"
                >
                  {{ column.label }}
                </th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container *ngIf="column.property === 'status'">
                    <p
                      *ngIf="
                        (row.encounterType === 'PQMED' ||
                          row.encounterType === 'AMED') &&
                        row.deposition_status === 'depositionCompleted'
                      "
                      class="status-completed w-[87px]"
                      matTooltip="Deposition completed"
                    >
                      <span class="text-base_green text-center">Completed</span>
                    </p>
                    <p
                      *ngIf="row.status === 'ANF'"
                      class="status-completed w-[87px]"
                    >
                      <span class="text-base_green text-center">ANF sent</span>
                    </p>
                    <p
                      *ngIf="row.status === 'draft'"
                      class="status-progress w-[87px]"
                    >
                      <span class="text-base_blue text-center">Draft</span>
                    </p>

                    <p
                      *ngIf="
                        row.status === 'Request' &&
                        !(
                          (row.encounterType === 'PQMED' ||
                            row.encounterType === 'AMED') &&
                          row.deposition_status === 'depositionCompleted'
                        )
                      "
                      class="status-req w-[87px]"
                    >
                      <span class="text-base_purple text-center"
                        >Requested</span
                      >
                    </p>
                  </ng-container>
                  <ng-container *ngIf="column.property !== 'status'">
                    {{
                      row[column.property] !== null &&
                      row[column.property] !== undefined &&
                      row[column.property] !== "" &&
                      row[column.property] !== "null" &&
                      row[column.property] !== "undefined"
                        ? row[column.property]
                        : ""
                    }}
                  </ng-container>
                </td>
              </ng-container>

              <ng-container
                *ngIf="column.type === 'verify'"
                [matColumnDef]="column.property"
              >
                <th
                  *matHeaderCellDef
                  class="sticky-header tabel_header"
                  mat-header-cell
                  mat-sort-header
                  [disabled]="!column.sortable"
                >
                  {{ column.label }}
                </th>
                <td
                  *matCellDef="let row"
                  [ngClass]="column.cssClasses"
                  mat-cell
                >
                  <ng-container *ngIf="column.property === 'status_2'">
                    <div class="flex gap-2 items-center">
                      <span
                        *ngIf="row.status_2 === 'progress'"
                        class="status-progress px-3 text-base_blue text-center"
                      >
                        In progress
                      </span>
                    </div>
                    <div class="flex gap-2 items-center">
                      <span
                        *ngIf="row.status_2 === 'draft'"
                        class="status-progress px-3 text-base_blue text-center"
                      >
                        Draft
                      </span>
                    </div>

                    <div class="flex gap-2 items-center">
                      <span
                        *ngIf="row.status_2 === 'Request'"
                        class="status-req px-3 text-base_purple text-center"
                      >
                        Requested
                      </span>
                    </div>

                    <div class="flex gap-2 items-center">
                      <span
                        *ngIf="row.status_2 === 'old'"
                        class="status-progress px-3 text-base_blue text-center"
                      >
                        Draft
                      </span>
                    </div>

                    <div class="flex gap-2 items-center">
                      <span
                        *ngIf="row.status_2 === 'completed'"
                        class="status-completed w-[99px] px-3 text-base_green text-center"
                      >
                        Completed
                      </span>
                    </div>

                    <div class="flex gap-2 items-center">
                      <span
                        *ngIf="
                          row.status_2 === 'failed' &&
                          row.reschedule_status === 'reschedule'
                        "
                        class="status-req w-[99px] px-3 text-base_purple text-center"
                      >
                        Rescheduled
                      </span>
                      <span
                        *ngIf="row.status_2 === 'failed'"
                        class="status-failed w-[99px] px-3 text-base_yellow text-center"
                      >
                        Appointment Failed
                      </span>
                    </div>
                    <div class="flex gap-2 items-center">
                      <span
                        *ngIf="
                          row.status_2 === 'cancelled' &&
                          row.reschedule_status === 'reschedule'
                        "
                        class="status-req w-[99px] px-3 text-base_purple text-center"
                      >
                        Rescheduled
                      </span>
                      <span
                        *ngIf="row.status_2 === 'cancelled'"
                        class="status-cancelled w-[99px] px-3 text-base_red text-center"
                      >
                        Appointment Cancelled
                      </span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="column.property !== 'status_2'">
                    {{ row[column.property] }}
                  </ng-container>
                </td>
              </ng-container>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th
                *matHeaderCellDef
                mat-header-cell
                class="sticky-header tabel_header"
              >
                Actions
              </th>
              <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
                <button
                  (click)="$event.stopPropagation()"
                  [matMenuTriggerData]="{ model: row }"
                  [matMenuTriggerFor]="actionsMenu"
                  mat-icon-button
                  type="button"
                >
                  <mat-icon [icIcon]="icMoreHoriz"></mat-icon>
                </button>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
            <tr
              *matRowDef="let row; columns: visibleColumns"
              @fadeInUp
              class="hover:bg-hover trans-ease-out"
              mat-row
            ></tr>
          </table>
          <div class="flex justify-center py-4" *ngIf="isScrollLoading">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </ng-container>
        <ng-template #noData>
          <div fxLayout="column" fxLayoutAlign="center center">
            <img class="h-40" src="assets/img/illustrations/idea.svg" />
            <h2 class="headline m-0 text-center mb-4">No Data found</h2>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
  <ng-template let-model="model" matMenuContent>
    <button
      *ngIf="model.draft == 'false' && model.isBulkIngested !== true && model.encounterType !== 'Personal Injury' && model.encounterType !== 'PQMED' && model.encounterType !== 'AMED' && model.ANFFileId"
      mat-menu-item
      type="button"
      (click)="redirectToURL(model.ANFFileId)"
    >
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        matTooltip="PDF"
        >picture_as_pdf</mat-icon
      >
      <span>View ANF</span>
    </button>

    <!-- <button *ngIf="model.draft === 'true'" matTooltip="Edit" [routerLink]="['/calendar/update_encounter/', model._id]" mat-menu-item>
      <mat-icon class="rounded px-2 py-1 qqmeIcon" style="background-color: rgb(5 26 202 / 20%)">edit</mat-icon>
      <span>Edit</span>
    </button> -->

    <button
      *ngIf="
        model.isCompletedPreIngestion !== true &&
        (model.isBulkIngested === true ||
          (model.draft == 'false' &&
            (model.encounterType == 'PQME' ||
              model.encounterType == 'PQMER' ||
              model.encounterType == 'PQMES' ||
              model.encounterType == 'PQMED' ||
              model.encounterType == 'AME' ||
              model.encounterType == 'AMER' ||
              model.encounterType == 'AMES' ||
              model.encounterType == 'Reflex PQMES' ||
              model.encounterType == 'Reflex AMES' ||
              model.encounterType == 'AMED')))
      "
      matTooltip="Edit"
      [routerLink]="['/calendar/update_encounter/', model._id]"
      mat-menu-item
    >
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        >edit</mat-icon
      >
      <span>Edit</span>
    </button>

    <button
      *ngIf="
        model.isCompletedPreIngestion !== true &&
        model.draft == 'true' &&
        (model.encounterType == 'PQME' ||
          model.encounterType == 'PQMER' ||
          model.encounterType == 'PQMES' ||
          model.encounterType == 'PQMED' ||
          model.encounterType == 'AME' ||
          model.encounterType == 'AMER' ||
          model.encounterType == 'AMES' ||
          model.encounterType == 'Reflex PQMES' ||
          model.encounterType == 'Reflex AMES' ||
          model.encounterType == 'AMED')
      "
      matTooltip="Edit"
      [routerLink]="['/calendar/update_encounter/', model._id]"
      mat-menu-item
    >
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        >edit</mat-icon
      >
      <span>Edit draft</span>
    </button>

    <button
      *ngIf="model.isCompletedPreIngestion !== true && model.draft == 'true' && model.encounterType == 'SIBTF'"
      matTooltip="Edit"
      [routerLink]="['/calendar/update_sibtf_encounter/', model._id]"
      mat-menu-item
    >
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        >edit</mat-icon
      >
      <span>Edit draft</span>
    </button>

    <button
      *ngIf="model.isCompletedPreIngestion !== true && model.draft == 'false' && model.encounterType === 'SIBTF'"
      matTooltip="Edit"
      [routerLink]="['/calendar/update_sibtf_encounter/', model._id]"
      mat-menu-item
    >
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        >edit</mat-icon
      >
      <span>Edit</span>
    </button>

    <button
      *ngIf="model.encounterType === 'Personal Injury' && model.draft !== 'true'"
      matTooltip="Edit"
      [routerLink]="['/calendar/update_pi_encounter', model._id]"
      mat-menu-item
    >
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        >edit</mat-icon
      >
      <span>Edit</span>
    </button>

    <button
      *ngIf="model.encounterType === 'Personal Injury' && model.draft === 'true'"
      matTooltip="Edit draft"
      [routerLink]="['/calendar/update_pi_encounter', model._id]"
      mat-menu-item
    >
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        >edit</mat-icon
      >
      <span>Edit draft</span>
    </button>

    <button matTooltip="Delete" mat-menu-item (click)="Delete(model._id)">
      <mat-icon
        class="rounded px-2 py-1 qqmeIcon"
        style="background-color: rgb(5 26 202 / 20%)"
        >delete</mat-icon
      >
      <span>Delete</span>
    </button>
  </ng-template>
</mat-menu>

<ng-template #pdfDialogTemplate>
  <mat-dialog-content>
    <!-- <button mat-button mat-dialog-close>Close</button> -->
    <iframe
      [src]="safeUrl"
      width="800"
      height="800"
      frameborder="0"
      allow="autoplay; encrypted-media"
    ></iframe>
  </mat-dialog-content>
</ng-template>
